import ReporteStockForm from './ReporteStockForm'
export {ReporteStockForm}
export default ReporteStockForm
